import React from "react";
import Loader from "./Loader";
import { Stack } from "@mui/material";
import { VideoCard, ChannelDetail } from "./";
import { Box } from "@mui/material";

const Video = ({ videos, direction }) => {
  if (!videos) return <Loader />;

  return (
    <Stack
      direction={direction ? direction : 'row'}
      flexWrap="wrap"
      justifyContent="start"
      alignItems="start"
      gap={3}
    >
      {videos?.items?.map((video, i) => (
        <Box>
        
        {video.id && <VideoCard key={i} item={video.snippet} videoId={video.id.videoId} /> }
        </Box>
      ))}
    </Stack>
  );
};

export default Video;
